import { styled } from 'common/src/designSystem/components/stitches';

export const MobileFullPage = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto'
});
